module.exports = __webpack_public_path__ + "img/@work_img5.c7f997fe.jpg";